"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "StepNoticeModel", {
    enumerable: true,
    get: function() {
        return StepNoticeModel;
    }
});
const _zod = require("zod");
const _metadatamodel = require("../metadata-model");
const _stepnoticetype = require("./step-notice-type");
const StepNoticeModel = _metadatamodel.MetadataModel.merge(_zod.z.object({
    id: _zod.z.string({
        description: 'The unique identifier of the step notice.'
    }).ulid(),
    stepId: _zod.z.string({
        description: 'The unique identifier of the step.'
    }).ulid(),
    order: _zod.z.number({
        description: 'The order index of the step notice.'
    }).int(),
    type: _zod.z.union([
        _zod.z.literal(_stepnoticetype.StepNoticeType.Info),
        _zod.z.literal(_stepnoticetype.StepNoticeType.Warning),
        _zod.z.literal(_stepnoticetype.StepNoticeType.Danger),
        _zod.z.literal(_stepnoticetype.StepNoticeType.Safety)
    ], {
        description: 'The type of the step notice.'
    })
}));

//# sourceMappingURL=step-notice-model.js.map